import { FaGreaterThan, FaLessThan } from "react-icons/fa";
import "./Pagination.css";
const Pagination = ({ currentPage, setCurrentPage }) => {
  return (
    <div className="page-main">
      <div className="page-section">
        <div className="pagination">
          <button className="greyButton" disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)}>
            <FaLessThan />
          </button>
          <span className="pagination-button">{currentPage}</span>
          <button className="greyButton" onClick={() => setCurrentPage((p) => p + 1)}>  <FaGreaterThan /> </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;